module.exports = __webpack_public_path__ + "static/media/logo.9755bf81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 7
// module chunks = 0